import { store } from '@/app/app-store';
import { DataOrigin } from '@/app/shared/enums';
import {
  ContractModel,
  DataFilterModel,
  PolicyModel,
} from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
  store,
  name: 'searchdataModule',
  namespaced: true,
  dynamic: true,
  //preserveState: localStorage.getItem('tracker') !== null,
})
export class DataModule extends VuexModule {
  public searchData: DataFilterModel = new DataFilterModel();
  public dataFilterList: DataFilterModel[] = [];
  public dataOrigin: DataOrigin = DataOrigin.Billing;

  public contractList: ContractModel[] = [];
  public policyList: PolicyModel[] = [];

  public searchDataLimit = 9;

  public get isBilling() {
    return (
      refs.enums.DataOrigin[this.dataOrigin] ==
        refs.enums.DataOrigin.Billing.toString() ||
      refs.enums.DataOrigin[this.dataOrigin] ==
        refs.enums.DataOrigin[refs.enums.DataOrigin.Billing]
    );
  }
  public get isInsurance() {
    return (
      refs.enums.DataOrigin[this.dataOrigin] ==
        refs.enums.DataOrigin.Insurance.toString() ||
      refs.enums.DataOrigin[this.dataOrigin] ==
        refs.enums.DataOrigin[refs.enums.DataOrigin.Insurance]
    );
  }

  @Mutation
  public SET_SEARCH_DATA(searchData: DataFilterModel) {
    this.searchData = searchData;
  }
  @Mutation
  public SET_DATA_FILTER_LIST(dataFilterList: DataFilterModel[]) {
    this.dataFilterList = dataFilterList.reduce((prev, curr) => {
      if (refs.enumHelper.dataOriginIsBilling(curr))
        curr.Contract =
          this.contractList.find((contract) => contract.Id == curr.Id) ||
          new ContractModel();
      else if (refs.enumHelper.dataOriginIsInsurance(curr))
        curr.Policy =
          this.policyList.find((policy) => policy.Id == curr.Id) ||
          new PolicyModel();
      prev.push(curr);
      return prev;
    }, [] as DataFilterModel[]);
  }
  @Mutation
  public SET_DATA_ORIGIN(dataOrigin: DataOrigin) {
    this.dataOrigin = dataOrigin;
  }
  @Mutation
  public SET_DATA_LIMIT(searchDataLimit: number) {
    this.searchDataLimit = searchDataLimit;
  }
  @Mutation
  public SET_CONTRACT_LIST(contractList: ContractModel[]) {
    this.contractList = contractList;
  }
  @Mutation
  public SET_POLICY_LIST(policyList: PolicyModel[]) {
    this.policyList = policyList;
  }

  @Action({ commit: 'SET_DATA_FILTER_LIST', rawError: true })
  public async loadDataFilterList() {
    const cleanDataFilter = Object.entries(this.searchData || {}).reduce(
      (a, [k, v]) => (v ? ((a[k as 'Number'] = v), a) : a),
      {} as DataFilterModel
    );

    const dataFilterList = refs._.isEmpty(cleanDataFilter)
      ? []
      : await refs.services.data.getDataFilterList(
          cleanDataFilter,
          this.searchDataLimit
        );
    const contractIdList: string[] = [];
    const policyIdList: string[] = [];

    const accounts = await refs.services.company.getAccountsByCompanyId(
      refs.modules.user.userInfo.company
    );

    accounts.forEach((account) => {
      dataFilterList.forEach((data) => {
        if (refs.enumHelper.dataOriginIsBilling(data))
          contractIdList.push(data.Id);
        else if (refs.enumHelper.dataOriginIsInsurance(data))
          policyIdList.push(data.Id);

        if (data.TenantId == account.Id) {
          data.TenantName = account.Name;
        }
      });
    });

    return dataFilterList;
  }
}
